var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 3.66406C32.1268 3.66406 40.3362 11.8734 40.3362 22.0002C40.3362 32.127 32.1268 40.3364 22 40.3364C11.8732 40.3364 3.66382 32.127 3.66382 22.0002C3.66382 11.8734 11.8732 3.66406 22 3.66406ZM22 6.41406C13.392 6.41406 6.41382 13.3922 6.41382 22.0002C6.41382 30.6082 13.392 37.5864 22 37.5864C30.608 37.5864 37.5862 30.6082 37.5862 22.0002C37.5862 13.3922 30.608 6.41406 22 6.41406ZM21.9933 19.2485C22.6894 19.248 23.2651 19.7649 23.3565 20.436L23.3692 20.6226L23.3758 30.7088C23.3763 31.4682 22.7611 32.0842 22.0017 32.0847C21.3056 32.0852 20.73 31.5683 20.6385 30.8972L20.6258 30.7106L20.6192 20.6244C20.6187 19.865 21.2339 19.249 21.9933 19.2485ZM22.0008 12.8359C23.012 12.8359 23.8317 13.6556 23.8317 14.6668C23.8317 15.6779 23.012 16.4977 22.0008 16.4977C20.9896 16.4977 20.1699 15.6779 20.1699 14.6668C20.1699 13.6556 20.9896 12.8359 22.0008 12.8359Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a685f487b4cfdedf0798eead61ec966c.svg";
export { ForwardRef as ReactComponent };